import ExportsHeaderCell from "./ExportsHeaderCell"
import { exports_table_header_cells } from "../../assets/data"

export default function ExportsHeader() {


    return <thead>
        <tr>
            {/* .filter(item => isInTab ? item.id !=1 : item) */}
            {/* if we are on tab and not on history page, remove the NG# and person name!!!  */}
            {exports_table_header_cells && exports_table_header_cells.map(item => (
                <th key={item.id} >
                    <ExportsHeaderCell item={item}/>
                </th>
            ))}
        </tr>
    </thead>
}